"use client"

import { motion } from "framer-motion"
import wave from "../assets/images/wave.png"

const TermsConditions = () =>    {
  return (
    <div className="min-h-screen">
      {/* Header Section with Wave */}
      <div className="relative bg-brand-navy">
        <div className="container mx-auto px-4 pt-8 sm:pt-16 pb-32 text-center text-white">
          <motion.h1
            className="font-outfit text-[28px] sm:text-[35px] md:text-[42px] lg:text-[44.47px] mt-10 sm:mt-10 font-[400] leading-[36px] sm:leading-[46px] md:leading-[56.03px] text-center mb-6 z-10 relative text-white sm:text-white sm:bg-white sm:bg-clip-text break-words"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Terms & Conditions
          </motion.h1>
          <motion.p
            className="text-white sm:text-white/90 z-10 relative text-sm sm:text-base mb-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Last Modified on: 31 Jan 2025
          </motion.p>
        </div>
        <div className="absolute bottom-[-18px] left-0 w-full hidden sm:block">
          <img
            src={wave}
            alt="wave"
            className="w-full"
          />
        </div>
        <div className="absolute bottom-[2rem] left-0 w-full sm:hidden">
          <img
            src={wave}
            alt="wave"
            className="w-full h-[13rem]"
          />
        </div>
      </div>

      {/* Content Section */}
      <div className="bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto space-y-8">
            <div className="space-y-4">
              <p className="text-gray-800">
                Welcome to EG to GO! These Terms & Conditions ("Terms") govern your use of our mobile application and
                services. By using our platform, you agree to these Terms.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">1. Definitions</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• "App" refers to the EG to GO mobile application.</li>
                <li>• "User" refers to individuals using the App for booking rides.</li>
                <li>• "Service Provider" refers to drivers or transportation companies offering services via the platform.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">2. Account Registration</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• Service providers must create an account and provide accurate, complete information.</li>
                <li>• It is your responsibility to maintain the confidentiality of your login details.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">3. Use of the Platform</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• Service providers agree to deliver high-quality and safe transportation services.</li>
                <li>• Misuse of the App or violation of applicable laws is prohibited.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">4. Payment and Fees</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• Service providers agree to the platform's commission structure.</li>
                <li>• Payments will be processed through the App, and earnings will be disbursed as per agreed terms.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">5. Service Obligations</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• Service providers must adhere to local transportation laws and maintain valid licenses and insurance.</li>
                <li>• Any complaints or disputes must be resolved promptly.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">6. Prohibited Activities</h2>
              <p className="text-gray-800">Service providers must not:</p>
              <ul className="space-y-2 text-gray-800">
                <li>• Engage in fraud or misrepresentation.</li>
                <li>• Use the platform for unlawful purposes.</li>
                <li>• Disclose sensitive customer information to unauthorized parties.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">7. Liability and Indemnity</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• EG to GO is not liable for accidents, damages, or disputes arising from the services provided.</li>
                <li>• Service providers indemnify EG to GO against claims resulting from their conduct or services.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">8. Termination</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• EG to GO reserves the right to suspend or terminate accounts for breach of these Terms.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">9. Dispute Resolution</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• Any disputes will be resolved through arbitration in Delhi, India.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">10. Changes to Terms</h2>
              <p className="text-gray-800">
                EG to GO may revise these Terms. Continued use of the platform constitutes acceptance of the updated Terms.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">Contact Information</h2>
              <p className="text-gray-800">
                For support, contact us at:<br />
                Email: support@egtogo.com<br />
                Phone: +91 9955210717
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">Acknowledgment</h2>
              <p className="text-gray-800 break-words">
                By using EG to GO, you acknowledge that you have read, understood, and agree to these Terms & Conditions and our Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsConditions
